import { TranslateHelper } from '@app/_helpers';
import { Component, Input } from '@angular/core';
import { Post } from '@interfaces/post';
import { RootService } from '@services/root.service';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { NgFor, DatePipe } from '@angular/common';

@Component({
    selector: 'app-widget-posts',
    templateUrl: './widget-posts.component.html',
    styleUrls: ['./widget-posts.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgFor, RouterLink, DatePipe, TranslateModule]
})
export class WidgetPostsComponent {
    @Input() posts: Post[] = [];
    @Input() header: string = "latest_posts"

    constructor(public root: RootService, public translateHelper: TranslateHelper) { }

    postImage(post: Post): string {
        return null;
    }
}
